//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { IFRAMES } from '@/js/constants';
export default {
  name: 'ContDataDashboard',
  data: function data() {
    return {
      srcEmbebed: IFRAMES['ContDataDashboard']
    };
  }
};